import React, { Fragment, useEffect } from 'react';
import { FieldValues, SubmitHandler, UseFormReturn } from 'react-hook-form';

export default function TriggerFormInitially<TFieldValues extends FieldValues = FieldValues, TContext = AnyValue>(
  props: UseFormReturn<TFieldValues, TContext>
): React.ReactElement {
  const { handleSubmit } = props;

  useEffect(() => {
    handleSubmit((() => undefined) as unknown as SubmitHandler<TFieldValues>)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Fragment />;
}
